/**
 * Client-side gate deciding whether an inbound message is worth asking the backend
 * to suggest a reply for. It suppresses ~60% of requests (non-questions), so we never
 * call the endpoint for "ok thanks" etc.
 *
 * This MUST stay in sync with the backend gate (the source of truth), in
 * reffie-backend `reffie/services/nudges/reply_suggestions/detection.py`.
 */

const GATE_MAX_LEN = 300;

const STARTERS =
    /^["'“‘\s]*(what|how|which|where|(is|are|when|can|could|do)\s|i['’]d like to|i would like to)/i;

const CONTAINS =
    /interested in|\btour|\bbed(room)?s?\b|\dbr\b|\d br\b|studio|availab|address|located|how much|send (me|us|it|the|a |an )|please send|(want|like) to (see|view|visit|come)/i;

export const passesReplyGate = (contents: string): boolean =>
    contents.length <= GATE_MAX_LEN &&
    (contents.includes('?') || STARTERS.test(contents) || CONTAINS.test(contents));
